import { createEventBus } from "../Common/eventBusFactory";

export const eventBus = createEventBus();

export const CHANGE_PARAMETER_SETTINGS = "onChangeParameterSettings";
export const ENABLE_EDIT_MODE = "onEnabledEditMode";
export const DELETE_PARAMETER_TREE = "onDeleteParameterTree";
export const OPEN_IMPORT_FROM_PAST_EVENT_MODAL = "onOpenImportFromPastEventModal";
